import { configureStore } from "@reduxjs/toolkit";
import { userReducer } from "./slices/UserSlice";
import { communityReducer } from "./slices/CommunitySlice";
import { usersReducer } from "./slices/UsersSlice";
import { leaderboardReducer } from "./slices/LeaderboardSlice";
import { matchReducer } from "./slices/MatchSlice";
import { pickemDetailsReducer } from "./slices/PickemDetailsSlice";
import { tournamentReducer } from "./slices/TournamentSlice";
import { tourReducer } from "./slices/TourSlice";
import { listenerMiddleware } from "./listenerMiddleware";
import { trackReducer } from "./slices/TrackSlice";

// Commented out reducers for data that's not currently being directly used
export const store = configureStore({
  reducer: {
    // driver: driverReducer,
    community: communityReducer,
    leaderboard: leaderboardReducer,
    match: matchReducer,
    pickemDetails: pickemDetailsReducer,
    // team: teamReducer,
    tour: tourReducer,
    tournament: tournamentReducer,
    track: trackReducer,
    user: userReducer,
    users: usersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // todo - is this desireable?
    }).prepend(listenerMiddleware.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
